export default __webpack_public_path__ + "97e3f60296a51948189d4b0b31dbba0d.png";